ko.components.register('domain-files-scan-tools', {
	viewModel: function(params) {
		var self = this;

		self.id = ko.observable(params.id);
		self.url = ko.observable(params.url || '');

		self.scanLabel = ko.observable(params.scanLabel || 'Scan Request');
		self.followLabel = ko.observable(params.followLabel || 'Follow Location');
		self.urlLabel = ko.observable(params.urlLabel || 'Scanner URL:');

		self.response = ko.observable("");
		self.error = ko.observable("");

		self.follow = ko.observable(false);

		self.loading = ko.observable(false);

		self.toggleFollow = function() {
			self.follow(!self.follow());
		};

	    self.scan = function() {
	    	if(self.loading() || !self.id())
	    		return;
    		self.loading(true);
			App.ajaxRequest('files/scan', {'id': self.id(), 'follow': (self.follow() ? 1 : 0)}, function(r){
				if(r && r.ok) {
					self.response(r.response ? r.response : "");
					self.error(r.error ? r.error : "");
				} else alert("Connection failure.");
			}).always(function(){ self.loading(false); });
		};
	},
	template: "<div class=\"alert alert-danger\" data-bind=\"visible: error().length > 0, text: error\"></div>\n<div class=\"mb-2\">\n\t<button class=\"btn btn-outline-secondary btn-sm mb-1 float-right\" data-bind=\"click: toggleFollow, css: {'active': follow}, attr: {'aria-pressed': follow()}, text: followLabel\"></button>\n\n\t<span data-bind=\"text: urlLabel\"></span>\n\t<a target=\"_blank\" data-bind=\"text: url, attr: {href: url}\"></a>\n\t<span class=\"spinner-border text-success spinner-border-sm\" data-bind=\"visible: loading()\"></span>\n</div>\n<button class=\"btn btn-primary btn-block\" data-bind=\"enable: !loading(), text: scanLabel, click: scan\"></button>\n<textarea class=\"form-control p-2\" data-bind=\"text: response\"></textarea>"
});